import React from 'react';
import AppModal from '../../common/AppModal';

export type DutyLogExportFormat = 'csv' | 'pdf' | 'legal-pdf';

interface DutyLogExportModalProps {
    isOpen: boolean;
    exporting: boolean;
    onClose: () => void;
    onExport: (format: DutyLogExportFormat) => void;
}

/**
 * #649 — Duty Log export dialog. Uses the shared AppModal so it has an explicit
 * top-right X (paradigm #2) plus a Cancel button, instead of the previous
 * click-away-only overlay. During an in-progress export, closing is blocked
 * (X hidden, overlay persistent) and the actions are disabled.
 */
const DutyLogExportModal: React.FC<DutyLogExportModalProps> = ({ isOpen, exporting, onClose, onExport }) => (
    <AppModal
        isOpen={isOpen}
        onClose={onClose}
        header="Export Duty Logs"
        width={420}
        showClose={!exporting}
        persistent={exporting}
    >
        <p>Choose export format:</p>
        <div className="dle-export-buttons">
            <button className="btn btn-primary" onClick={() => onExport('csv')} disabled={exporting}>CSV</button>
            <button className="btn btn-primary" onClick={() => onExport('pdf')} disabled={exporting}>PDF</button>
            <button className="btn btn-primary" onClick={() => onExport('legal-pdf')} disabled={exporting}>PDF (Legal)</button>
        </div>
        {exporting && <p style={{ marginTop: '12px', fontStyle: 'italic' }}>Generating export...</p>}
        <div className="dle-export-footer" style={{ marginTop: '16px', textAlign: 'right' }}>
            <button className="btn btn-neutral" onClick={onClose} disabled={exporting}>Cancel</button>
        </div>
    </AppModal>
);

export default DutyLogExportModal;
